import { SiteModule } from './components/site/site.module';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './components/site/home/home.component';


const routes: Routes = [
  { path: '', component:HomeComponent},
  { path: 'home',
    redirectTo:'',
    pathMatch:'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes,{
    onSameUrlNavigation: 'reload',
    scrollPositionRestoration: 'enabled'
  }),SiteModule],
  exports: [RouterModule]
})

export class AppRoutingModule { }
